// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PInterationOutlinedSvg from "@fishx/icons-svg/es/asn/PInterationOutlined";
import FishxIcon from '../components/FishxIcon';

var PInterationOutlined = function PInterationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PInterationOutlinedSvg
  }));
};

PInterationOutlined.displayName = 'PInterationOutlined';
export default React.forwardRef(PInterationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PInterationOutlined.js
// module id = 3463
// module chunks = 0